'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
var Button = require('../../Inputs/Button/Button.js');

const DialogBox = ({ title, description, variant = 'primary', onClose, onConfirm, confirm, close = '닫기', testId })=>{
    const isCaution = variant === 'caution';
    return jsxRuntime.jsxs(Box, {
        className: "flex h-fit flex-col items-center gap-8 rounded-3xl bg-w-white p-8 font-normal not-italic shadow-modal tablet:w-[400px]",
        "data-testid": testId || 'design-system--dialog-box',
        children: [
            jsxRuntime.jsxs(Box, {
                className: "flex w-full flex-col gap-6",
                children: [
                    jsxRuntime.jsx(Typography, {
                        variant: "subTitle2",
                        className: "font-medium text-w-gray-900",
                        children: title
                    }),
                    jsxRuntime.jsx(Typography, {
                        variant: "body1",
                        className: "whitespace-break-spaces text-w-gray-800",
                        children: description
                    })
                ]
            }),
            jsxRuntime.jsxs(Box, {
                className: "flex w-full items-center justify-end gap-4",
                children: [
                    close && jsxRuntime.jsx(Button, {
                        role: "close",
                        onClick: onClose,
                        variant: "solid",
                        className: "border-w-bluegray-200 bg-w-bluegray-200 hover:border-w-bluegray-300 hover:bg-w-bluegray-300",
                        children: close
                    }),
                    confirm && jsxRuntime.jsx(Button, {
                        role: "confirm",
                        onClick: onConfirm,
                        variant: "solid",
                        className: tailwindMerge.twJoin(isCaution && 'border-w-orange-500 bg-w-orange-500 hover:border-w-orange-600 hover:bg-w-orange-600'),
                        children: confirm
                    })
                ]
            })
        ]
    });
};

module.exports = DialogBox;
